import { useRef, useState } from 'react';

import { useHistory } from 'react-router-dom';

import useUnsavedChangesProtection from 'hooks/useUnsavedChangesProtection/useUnsavedChangesProtection';
import PATHS from 'router/PATHS';

type UseActionTemplateFormManagerProps = {
  isEditMode?: boolean;
  templateId?: number;
};

const useActionTemplateFormManager = ({ isEditMode = false, templateId }: UseActionTemplateFormManagerProps) => {
  const history = useHistory();
  const [isDirty, setIsDirty] = useState(false);
  const saveHandlerRef = useRef<(() => Promise<void>) | null>(null);

  const handleNavigate = () => {
    if (isEditMode && templateId) {
      history.push(PATHS.ACTION_LIBRARY_DETAIL.replace(':id', templateId.toString()));
    } else {
      history.push(PATHS.ACTION_LIBRARY);
    }
  };

  const handleSave = async () => {
    if (saveHandlerRef.current) {
      await saveHandlerRef.current();
    }
  };

  const { handleNavigation, NavigationPrompt } = useUnsavedChangesProtection({
    isDirty,
    onSave: handleSave,
    onNavigate: handleNavigate,
    enabled: true,
  });

  return {
    isDirty,
    setIsDirty,
    saveHandlerRef,
    handleNavigation,
    NavigationPrompt,
  };
};

export default useActionTemplateFormManager;
